interface HexToRgbaProps {
  hex: string;
  alpha: number;
}

export const hexToRgba = ({ hex, alpha }: HexToRgbaProps): string => {
  if (!hex) return `rgba(0, 0, 255, ${alpha})`;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return `rgba(0, 0, 255, ${alpha})`;
  return `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})`;
};
